import { render, staticRenderFns } from "./AmendmentComment.vue?vue&type=template&id=4da152d7"
import script from "./AmendmentComment.vue?vue&type=script&lang=js"
export * from "./AmendmentComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da152d7')) {
      api.createRecord('4da152d7', component.options)
    } else {
      api.reload('4da152d7', component.options)
    }
    module.hot.accept("./AmendmentComment.vue?vue&type=template&id=4da152d7", function () {
      api.rerender('4da152d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/AmendmentComment.vue"
export default component.exports